/**
 * Mock Diamond Data for Platform Demo
 *
 * This file contains sample diamond data used for demonstrating the platform
 * features to users who don't have access to the live inventory.
 *
 * Each diamond object includes:
 * - Basic specs: shape, carat, color, clarity, cut
 * - Pricing: both USD value and formatted string
 * - Certification: lab/certification info
 * - Image URLs: for visual display
 * - Status flags: availability, featured, certified
 */
export const SAMPLE_DIAMONDS = [
    {
        id: '001',
        shape: 'Round',
        caratWeight: 2.01,
        carat: '2.01',
        color: 'D',
        clarity: 'VVS1',
        cut: 'Excellent',
        price: '$42,500',
        priceUSD: 42500,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: true,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/round.png',
        imageFilename: 'round.png'
    },
    {
        id: '002',
        shape: 'Princess',
        caratWeight: 1.52,
        carat: '1.52',
        color: 'E',
        clarity: 'VS1',
        cut: 'Excellent',
        price: '$18,900',
        priceUSD: 18900,
        certification: 'AGS',
        lab: 'AGS',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/princess.png',
        imageFilename: 'princess.png'
    },
    {
        id: '003',
        shape: 'Emerald',
        caratWeight: 3.21,
        carat: '3.21',
        color: 'F',
        clarity: 'VS2',
        cut: 'Very Good',
        price: '$58,000',
        priceUSD: 58000,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: true,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/emerald.png',
        imageFilename: 'emerald.png'
    },
    {
        id: '004',
        shape: 'Oval',
        caratWeight: 1.75,
        carat: '1.75',
        color: 'G',
        clarity: 'SI1',
        cut: 'Excellent',
        price: '$12,400',
        priceUSD: 12400,
        certification: 'IGI',
        lab: 'IGI',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/oval.png',
        imageFilename: 'oval.png'
    },
    {
        id: '005',
        shape: 'Cushion',
        caratWeight: 2.50,
        carat: '2.50',
        color: 'H',
        clarity: 'VS2',
        cut: 'Good',
        price: '$22,800',
        priceUSD: 22800,
        certification: 'HRD',
        lab: 'HRD',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/cushion.png',
        imageFilename: 'cushion.png'
    },
    {
        id: '006',
        shape: 'Pear',
        caratWeight: 1.20,
        carat: '1.20',
        color: 'I',
        clarity: 'SI2',
        cut: 'Very Good',
        price: '$8,500',
        priceUSD: 8500,
        certification: 'EGL',
        lab: 'EGL',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/pear.png',
        imageFilename: 'pear.png'
    },
    {
        id: '007',
        shape: 'Marquise',
        caratWeight: 1.85,
        carat: '1.85',
        color: 'J',
        clarity: 'VS1',
        cut: 'Excellent',
        price: '$15,200',
        priceUSD: 15200,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/marquise.png',
        imageFilename: 'marquise.png'
    },
    {
        id: '008',
        shape: 'Radiant',
        caratWeight: 2.80,
        carat: '2.80',
        color: 'D',
        clarity: 'IF',
        cut: 'Excellent',
        price: '$68,000',
        priceUSD: 68000,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: true,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/radiant.png',
        imageFilename: 'radiant.png'
    },
    {
        id: '009',
        shape: 'Heart',
        caratWeight: 1.45,
        carat: '1.45',
        color: 'K',
        clarity: 'SI1',
        cut: 'Good',
        price: '$9,800',
        priceUSD: 9800,
        certification: 'IGI',
        lab: 'IGI',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/heart.png',
        imageFilename: 'heart.png'
    },
    {
        id: '010',
        shape: 'Asscher',
        caratWeight: 2.12,
        carat: '2.12',
        color: 'E',
        clarity: 'VVS2',
        cut: 'Excellent',
        price: '$35,600',
        priceUSD: 35600,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: true,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/asscher.png',
        imageFilename: 'asscher.png'
    },
    {
        id: '011',
        shape: 'Round',
        caratWeight: 0.75,
        carat: '0.75',
        color: 'G',
        clarity: 'VVS2',
        cut: 'Ideal',
        price: '$4,200',
        priceUSD: 4200,
        certification: 'AGS',
        lab: 'AGS',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/round.png',
        imageFilename: 'round.png'
    },
    {
        id: '012',
        shape: 'Princess',
        caratWeight: 3.05,
        carat: '3.05',
        color: 'H',
        clarity: 'SI1',
        cut: 'Fair',
        price: '$28,900',
        priceUSD: 28900,
        certification: 'HRD',
        lab: 'HRD',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/princess.png',
        imageFilename: 'princess.png'
    },
    {
        id: '013',
        shape: 'Oval',
        caratWeight: 4.12,
        carat: '4.12',
        color: 'I',
        clarity: 'VS1',
        cut: 'Very Good',
        price: '$45,800',
        priceUSD: 45800,
        certification: 'EGL',
        lab: 'EGL',
        status: 'available',
        certified: true,
        featured: true,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/oval.png',
        imageFilename: 'oval.png'
    },
    {
        id: '014',
        shape: 'Emerald',
        caratWeight: 1.88,
        carat: '1.88',
        color: 'J',
        clarity: 'SI2',
        cut: 'Good',
        price: '$14,500',
        priceUSD: 14500,
        certification: 'IGI',
        lab: 'IGI',
        status: 'reserved',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/emerald.png',
        imageFilename: 'emerald.png'
    },
    {
        id: '015',
        shape: 'Cushion',
        caratWeight: 1.67,
        carat: '1.67',
        color: 'F',
        clarity: 'IF',
        cut: 'Excellent',
        price: '$25,400',
        priceUSD: 25400,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: true,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/cushion.png',
        imageFilename: 'cushion.png'
    },
    // Additional affordable round diamonds for better search results
    {
        id: '016',
        shape: 'Round',
        caratWeight: 0.50,
        carat: '0.50',
        color: 'H',
        clarity: 'VS1',
        cut: 'Excellent',
        price: '$2,800',
        priceUSD: 2800,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/round.png',
        imageFilename: 'round.png'
    },
    {
        id: '017',
        shape: 'Round',
        caratWeight: 0.65,
        carat: '0.65',
        color: 'G',
        clarity: 'VS2',
        cut: 'Excellent',
        price: '$3,500',
        priceUSD: 3500,
        certification: 'AGS',
        lab: 'AGS',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/round.png',
        imageFilename: 'round.png'
    },
    {
        id: '018',
        shape: 'Round',
        caratWeight: 0.80,
        carat: '0.80',
        color: 'F',
        clarity: 'VS1',
        cut: 'Ideal',
        price: '$4,950',
        priceUSD: 4950,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: true,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/round.png',
        imageFilename: 'round.png'
    },
    {
        id: '019',
        shape: 'Round',
        caratWeight: 0.55,
        carat: '0.55',
        color: 'I',
        clarity: 'SI1',
        cut: 'Very Good',
        price: '$1,800',
        priceUSD: 1800,
        certification: 'IGI',
        lab: 'IGI',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/round.png',
        imageFilename: 'round.png'
    },
    {
        id: '020',
        shape: 'Princess',
        caratWeight: 0.72,
        carat: '0.72',
        color: 'G',
        clarity: 'VS1',
        cut: 'Excellent',
        price: '$3,200',
        priceUSD: 3200,
        certification: 'GIA',
        lab: 'GIA',
        status: 'available',
        certified: true,
        featured: false,
        imageUrl: 'https://blobaneesh.blob.core.windows.net/images/diamondshape/princess.png',
        imageFilename: 'princess.png'
    }
];
